import { Component, HostBinding, Input } from '@angular/core'

@Component({
    selector: 'mg-summary-card-column',
    templateUrl: './summary-card-column.component.html',
    styleUrls: ['./summary-card-column.component.scss'],
})
export class SummaryCardColumnComponent {
    @Input()
    label: string

    @Input()
    span: 1 | 2 = 1

    constructor() {}

    @HostBinding('class.summary-card-column--span-2')
    get gridColumnSpan2() {
        return this.span === 2
    }
}
